let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7Q0UC"), load("dTsOE"), load("19qJC")]).then(() => parcelRequire('jl3SG'));